import { render, staticRenderFns } from "./TestPurchaseHint.vue?vue&type=template&id=e09c5adc&scoped=true"
import script from "./TestPurchaseHint.vue?vue&type=script&lang=js"
export * from "./TestPurchaseHint.vue?vue&type=script&lang=js"
import style0 from "./TestPurchaseHint.vue?vue&type=style&index=0&id=e09c5adc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e09c5adc",
  null
  
)

export default component.exports